const getSubtitleVideoRef = (name?: string): string[] => {
  if (!name) return [];

  return name.split("-REF=", 2);
};

export default getSubtitleVideoRef;
